import {Inject, Injectable} from '@angular/core';
import {FileAttachment} from '../model/file-attachment.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FileApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getFile(guid: string) {
        return this.http.get(this.baseUri + '/File/' + guid, {
            responseType: 'blob'
        }).pipe(
            map(this.mapFileResponse)
        );
    }

    getFileBlob(guid: string) : Observable<Blob>  {
        return this.http.get(this.baseUri + '/File/' + guid, {
            responseType: 'blob'
        })
    }

    getFileResponse(guid: string) {
        return this.http.get(this.baseUri + '/File/' + guid, {
            responseType: 'blob'
        })
    }



    getFilesForItem(type: number, typeId: string) {
        return this.http.get(this.baseUri + '/Files/Item/' + type + '/' + typeId);
    }

    uploadFile({ fileList, type, typeId, portalId, fileId, displayName }: { fileList: FileList; type: number; typeId: string; portalId: number; fileId?: string; displayName?: string;}) {
        let file: File = fileList[0];
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('Type', type.toString());
        formData.append('TypeId', typeId);
        formData.append('DisplayName',displayName);
        formData.append('PortalId', portalId.toString());
        
        if (fileId) {
            formData.append('FileId', fileId);
        }

        return this.http.post(this.baseUri + '/File', formData);
    }

    uploadSignature(
        { signature, type, typeId, subTypeId, portalId, fileId }:
        { signature: Blob; type: number; typeId: string; subTypeId: number; portalId: number; fileId?: string; }) {
        let formData: FormData = new FormData();
        formData.append('file', signature, 'signature.png');
        formData.append('Type', type.toString());
        formData.append('TypeId', typeId);
        formData.append('SubTypeId', subTypeId.toString());
        formData.append('PortalId', portalId.toString());

        if (fileId) {
            formData.append('FileId', fileId);
        }

        return this.http.post(this.baseUri + '/File', formData);
    }

    deleteFile(file: FileAttachment) {
        return this.http.request('delete', this.baseUri + '/File', {
            responseType: 'text',
            body: file
        });
    }
}